// Domain
import { InvestmentProductFundTypeEntity } from '../entities/investment-product-fund-type-entity';

export default class InvestmentProductFundTypeState {
  loaded = false;

  items: Array<InvestmentProductFundTypeEntity> = [];
}
